import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asasyllabus',
  templateUrl: './asasyllabus.component.html',
  styleUrls: ['./asasyllabus.component.scss']
})
export class AsasyllabusComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
